'use client';
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { ColorSwatchesContext } from './color-swatches.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)t = s[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)t = s[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const ColorSwatches = renderWithRef('ColorSwatches', null, (o, s)=>{
    var { children: c, labelPosition: l = 'top', size: i = 'standard' } = o, a = _object_without_properties(o, [
        "children",
        "labelPosition",
        "size"
    ]);
    let p = new Set([
        'swan-color-swatches'
    ]);
    'standard' != i && p.add(`swan-color-swatches-${i}`);
    let u = useMemo(()=>({
            labelPosition: l
        }), [
        l
    ]);
    return jsx(ColorSwatchesContext.Provider, {
        value: u,
        children: jsx(RenderComp, {
            root: "div",
            classNames: p,
            forwardedRef: s,
            props: a,
            children: c
        })
    });
});

export { ColorSwatches };
